// app.config.ts tags events with service `future-room`. The same application
// id is shared with environment.production.ts and distinguished by the `env`
// tag, matching edu-clients' own RUM app
// (same datadogAppId for staging and production there too).
//
// This file is swapped in for src/environments/environment.ts via
// angular.json's `fileReplacements` under the "staging" build
// configuration - it is not read from a `.env` file or any environment-
// variable mechanism. See AGENTS.md's "Known upstream issues" /
// load-bearing workarounds notes for the fuller picture.
// apps.* URLs are proxied through edge-gateway (antares), same as edu-clients'
// apps config - copied from edu-clients/src/environments/environment.staging.ts
// rather than re-derived, since these are the same backend services.
import { previewClientId } from './release';

const edgeGatewayUrl = 'https://staging-api.presence.com';

export const environment = {
  datadogApplicationId: '80b73d4f-74e4-41ab-ac57-3e75cba8d83f',
  datadogClientToken: 'pube980f5436e07d7bf3c82efeb63f8fd0b',
  env: 'staging',
  configCatKey: 'configcat-sdk-1/DgLbCHEjckGEDa0uS7QeUQ/rK44dge5j02ceGUeOlJwlQ',
  apps: {
    apiWorkplace: {
      url: `${edgeGatewayUrl}/workplace`,
    },
    chiron: {
      url: `${edgeGatewayUrl}/chiron`,
    },
    mizar: {
      url: `${edgeGatewayUrl}/mizar`,
    },
    sirius: {
      url: `${edgeGatewayUrl}/sirius`,
    },
  },
  // clientId matches sirius/pkg/config/oidc.go's `{Name}-{env}` convention -
  // sirius registers `future-room-staging` for its own "staging" env on
  // startup (see the `future-room` clientParams entry added alongside
  // this), so this is a real, working client, not a placeholder.
  auth: {
    issuerUrl: `${edgeGatewayUrl}/sirius/v1`,
    // Previews replace this with the ephemeral client id stamped into release.ts.
    clientId: previewClientId || 'future-room-staging',
  },
  lessonspaceDoorUrl: 'https://staging-door.presence-cf.workers.dev',
  // HiLink is not offered in production. Staging and local dev show it.
  hilinkMeetings: true,
};
